import { render, staticRenderFns } from "./BoxContainerLoading.vue?vue&type=template&id=025b62c2&"
import script from "./BoxContainerLoading.vue?vue&type=script&lang=js&"
export * from "./BoxContainerLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports